import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { SBRouteData, SideNavItem } from '@modules/navigation/models';
import { NavigationService, SideNavService } from '@modules/navigation/services';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ExitImpersonationModalComponent } from '@app/components/exit-impersonation-modal/exit-impersonation-modal.component';
import { ExitImpersonationConfirmModalComponent } from '@app/components/exit-impersonation-confirm-modal/exit-impersonation-confirm-modal.component';
import { UserService } from '@modules/auth/services';
import { ApiRequestService } from '@common/services/api-request.service';
import { ToastService } from '@common/services/toast.service';
import { getAuth, signOut } from 'firebase/auth';
import { SecureStorageService } from '@app/services/secure-storage.service';
import { AuthTokenStoreService } from '@app/services/auth-token-store.service';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../../app/services/data.service';
import { firstValueFrom } from 'rxjs';
import { PermissionsService } from '@app/services/permissions.service';
import { ThemeRuntimeService } from '@app/services/theme-runtime.service';
import { Subject, takeUntil } from 'rxjs';
import {
    canExitImpersonation,
    clearImpersonationOrigin,
} from '@app/utils/impersonation-session.util';

@Component({
    selector: 'sbpro-top-nav-user',
    templateUrl: './top-nav-user.component.html',
    styleUrls: ['top-nav-user.component.scss'],
    standalone: false
})
export class TopNavUserComponent implements OnInit, OnDestroy {
    @Input() placement = 'bottom-end';
    dropdownClasses: string[] = [];
    username:any = "";
    email:any = "";
    @Input() impersination!: string;

    meteringFarms: any = [];
    meteringSections: any = [];
    meteringPointsArr: any = [];
    meteringPoints: any = [];
    deviceList: any = [];
    createAccountBtn = 'yes';

    deviceManagement = "";
    meteringSectionManagement = "";
    meteringPointManagement = "";
    companyCheck = localStorage.getItem('company');
    accountIconUrl = this.companyCheck == 'landis'
        ? 'assets/landis-assets/images/sidebar_logo.png'
        : this.companyCheck == 'eykon'
            ? 'assets/eykon-assets/images/eykon-logo.png'
            : 'assets/dashboard/sidebar/logo.svg';
    unapprovedRegisteredUser: any;
    private readonly destroy$ = new Subject<void>();

    private lastToastID?: string;
    private lastToastTooManyRequest?: string;

    constructor(
        public userService: UserService,
        private apiRequest: ApiRequestService,
        private modalService: NgbModal,
        public navigationService: NavigationService,
        private router: Router,
        private toastService: ToastService, 
        private changeDetectorRef: ChangeDetectorRef,
        private secureStorage:SecureStorageService,
        private authTokenStore: AuthTokenStoreService,
        private cookieService: CookieService,
        private dataService:DataService,
        private permissionsService: PermissionsService,
        private themeRuntimeService: ThemeRuntimeService,
    ) {}
    async ngOnInit() {

        this.unapprovedRegisteredUser = localStorage.getItem('unapprovedRegisteredUser')
      
        this.username = await this.secureStorage.getItem('name');
        this.email = await this.secureStorage.getItem('email');
       
        
        if(localStorage.getItem('impersination') == "yes"){
            this.impersination = "yes";
        }
        this.accountIconUrl = this.themeRuntimeService.getActiveBranding().accountIcon;
        this.themeRuntimeService.branding$
            .pipe(takeUntil(this.destroy$))
            .subscribe((branding) => {
                this.accountIconUrl = branding.accountIcon;
                this.changeDetectorRef.markForCheck();
            });
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    canExitImpersonation(): boolean {
        return canExitImpersonation();
    }

    async logout() {

       await this.logoutFromBackend()


        const auth = getAuth();
        /*  if(localStorage.getItem("socialUser") && localStorage.getItem("socialUser") != "") {
                localStorage.clear();
                localStorage.setItem("socialUser", "socialUser");
            }else{
                localStorage.clear();
            }
            //this.router.navigateByUrl("/auth/login");
            window.location.assign("/auth/login"); */
    
    
        try {
          // Sign out the user from Firebase Authentication
          await signOut(auth);
          console.log('User signed out successfully');
          const bulkIds = localStorage.getItem("bulkIds");
          const selectedMeter = localStorage.getItem("selectedMeter");
          const meterSectionIdSync = localStorage.getItem("meterSectionIdSync");
          const companyCheck = localStorage.getItem("company");
      
          localStorage.clear();
          sessionStorage.clear();
          await this.secureStorage.clearStorage();
          this.authTokenStore.clear();
          this.authTokenStore.clearAuthCookies();
          this.cookieService.deleteAll('/');
          if (companyCheck == "landis" || companyCheck == "eykon") {
            localStorage.setItem("company", companyCheck);
          }
      
          if (bulkIds) {
            localStorage.setItem("selectedMeter", selectedMeter ?? "");
            localStorage.setItem("bulkIds", bulkIds);
            localStorage.setItem("selectedBulkIds", "yes");
          }
      
          if (meterSectionIdSync) {
            localStorage.setItem("meterSectionIdSync", meterSectionIdSync);
          }
          window.location.assign("/auth/login");
          
          // Redirect to login or home page, depending on your app's flow
          // this.router.navigate(['/login']); // Uncomment and configure routing as needed
        } catch (error: unknown) {
          // Handle error properly by checking its type and casting it
          if (error instanceof Error) {
            console.error('Error signing out:', error.message);
          } else {
            console.error('Unexpected error during logout:', error);
          }
        }

      

      }


    openExitImpersonationModal() {
        if (!this.canExitImpersonation()) {
            return;
        }

        const modalRef = this.modalService.open(ExitImpersonationModalComponent, { backdrop: 'static', centered: true });
        modalRef.componentInstance.passwordSubmit.subscribe((password: string) => {
            this.exitImpersination(password, modalRef);
        });
    }

    openExitImpersonationConfirmModal() {
        if (!this.canExitImpersonation()) {
            return;
        }

        const modalRef = this.modalService.open(ExitImpersonationConfirmModalComponent, { backdrop: 'static', centered: true });
        modalRef.result.then((result) => {
            if (result === 'continue') {
                this.openExitImpersonationModal();
            }
        }).catch(() => {});
    }

    exitImpersination(password: string, modalRef: NgbModalRef) {
        if (!this.canExitImpersonation()) {
            modalRef.dismiss();
            return;
        }

        let body = {
          payload: {
            userID: parseInt(localStorage.getItem('impersonateUserID') as string),
            mainUserID: parseInt(localStorage.getItem('impersonateUserID') as string),
            password: password
          },
        };

    this.dataService.resetTariffReviewState();

        // localStorage.setItem("access_token", localStorage.getItem('main_token') as string);
        // localStorage.setItem("mainUserID", localStorage.getItem('userID') as string);
       
        this.changeDetectorRef.detectChanges();
        
        this.apiRequest.apiRequest("auth/exit_impersonate_account/", "back_to_main.json", body)
        .subscribe(async (res) => {
            if (res.data.userID) {
                this.themeRuntimeService.applyLoginResponseTheme(
                    res?.data?.organisation ?? res?.data?.organization ?? res.data,
                    true
                );
                 localStorage.setItem("impersination", 'no');
                 localStorage.removeItem("impersonatingUserID");
                 clearImpersonationOrigin();
                 localStorage.setItem("meteringPointStatement", "no");
                this.impersination = "no";
                localStorage.setItem("userID", res.data.userID);
                let accessToken = this.dataService.encryptToken(res.data.access.access_token, res.data.userID as string);
                let refreshToken = this.dataService.encryptToken(res.data.access.refresh_token, res.data.userID as string);

                this.cookieService.set('djkn445fk45jk:dfd553dfgf', res.data.userID, {
                          path: '/',
                          secure: true,
                          sameSite: 'Strict',
                          // Set cookie expiration to 1 day
                          expires: new Date(Date.now() + 24 * 60 * 60 * 1000) // 1 day
               });


                this.cookieService.set('78Hu78h8:383673:esd838d7s6s7w', accessToken, {
                    path: '/',
                    secure: true,
                    sameSite: 'Strict',
                    // Set cookie expiration to 1 day
                    expires: new Date(Date.now() + 24 * 60 * 60 * 1000) // 1 day
                });
                this.cookieService.set('78Hu78h8:383673:748388388hh43', refreshToken, {
                    path: '/',
                    secure: true,
                    sameSite: 'Strict',
                    // Set cookie expiration to 1 day
                    expires: new Date(Date.now() + 24 * 60 * 60 * 1000) // 1 day
                });

                this.authTokenStore.storeSessionTokens(
                    {
                        userId: res.data.userID,
                        accessToken: res.data.access.access_token,
                        refreshToken: res.data.access.refresh_token,
                    },
                    true
                );

                await this.secureStorage.setItem('username',  res.data.name);
                await this.secureStorage.setItem('email',  res.data.email);
                await this.secureStorage.setItem("permissions",  JSON.stringify(res.data.access.permissions));
                await this.secureStorage.setItem("companyName", res.data.companyName);

        
                localStorage.setItem("pmLevel", res.data.pmLevel);

                localStorage.setItem("impersination", 'no');
                localStorage.setItem("reload", 'yes');

                localStorage.removeItem('deviceID');
                setTimeout(() => {
                    // this.router.navigateByUrl(url);
                    // window.location.assign("/dashboard")
                    this.getMeteringHierachy();
                    this.getAccountHierachyReload();
                }, 500)

            }
            this.changeDetectorRef.detectChanges();
            modalRef.close();
          },
          (error: any) => {
              const defaultOptions = {
                  autohide: true,
                  delay: 5000,
              };

              console.log(error);   
                     
                if (this.lastToastTooManyRequest && error.status !== 429) {
                    this.toastService.remove(this.lastToastTooManyRequest);
                    this.lastToastTooManyRequest = undefined;
                }

                if (error.status === 401 || error.status === 403) {
                    if (this.lastToastID) {
                        this.toastService.remove(this.lastToastID);
                    }

                    this.lastToastID = this.toastService.show(
                        'Exit Impersonation',
                        'Incorrect password. Please try again.',
                        { headerClasses: 'bg-danger text-light' }
                    );

                } else if (error.status === 429) {
                    if (this.lastToastTooManyRequest) {
                        this.toastService.remove(this.lastToastTooManyRequest);
                    }

                    const message = error.error?.data?.[0] || 'Too many requests. Please try again later.';

                    this.lastToastTooManyRequest = this.toastService.show(
                        'Exit Impersonation',
                        message,
                        { headerClasses: 'bg-danger text-light' }
                    );
                } else {
                  let message = "";
                  for(var i=0; i < error.error.data.length; i++){
                      message += error.error.data[i]+"\n";
                  }
                  this.toastService.show("Exit Impersonation", "Something went wrong", { headerClasses: 'bg-danger text-light',  });
              }
              modalRef.componentInstance.isSubmitting = false;
          });
    
      }


    getAccountHierachyReload() {
        let body = {
            payload: {
                userID: parseInt(localStorage.getItem("userID") as string),
            },
        };
        localStorage.setItem("active", "dashboard");

        let jsonF = "account_hierarchy.json";
        if (localStorage.getItem("pmLevel") == "1") {
            jsonF = "account_hierarchy.json";
        }
        if (localStorage.getItem("pmLevel") == "2") {
            jsonF = "account_hierarchy_2.json";
        }
        else if (localStorage.getItem("pmLevel") == "3" || localStorage.getItem("pmLevel") == "4") {
            jsonF = "account_hierarchy_3.json";
        }

        const defaultOptions = {
            autohide: true,
            delay: 10000,
        };

        this.apiRequest.apiRequest("metering/account_hierarchy/", jsonF, body)
            .subscribe((res) => {
                console.log(res.message);
                if (res.success) {
                    console.log('Save json account_hierarchy');

                }
                
            },
                (error: any) => {
                    const defaultOptions = {
                        autohide: true,
                        delay: 10000,
                    };
                    console.log(error);
                    let message = "";
                    for (var i = 0; i < error.error.data.length; i++) {
                        message += error.error.data[i] + "\n";
                    }
                    this.toastService.show("Smart-View Login", "You account setup is not complete. \nContact your Administrator for more information.", { headerClasses: 'bg-danger text-light', ...defaultOptions })
                });
    }


      async getMeteringHierachy() {
        let body = {
            payload: {
                userID: parseInt(localStorage.getItem("userID") as string),
            },
        };
        localStorage.setItem("active", "dashboard");

        let permissions:any = this.permissionsService.getAll();
        // let permissions:any = await this.secureStorage.getItem('permissions');
        // permissions =  JSON.parse(permissions);
  

        this.deviceManagement = permissions.deviceManagement;
        this.meteringSectionManagement = permissions.meteringSectionManagement;
        this.meteringPointManagement = permissions.meteringPointManagement;

        let jsonF = "metering_hierarchy.json";
        if (localStorage.getItem("pmLevel") == "1") {
            jsonF = "metering_hierarchy.json";
        }
        if (localStorage.getItem("pmLevel") == "2") {
            jsonF = "metering_hierarchy_2.json";
        }
        else if (localStorage.getItem("pmLevel") == "3" || localStorage.getItem("pmLevel") == "4") {
            jsonF = "metering_hierarchy_3.json";
        }

        const defaultOptions = {
            autohide: true,
            delay: 10000,
        };

        //var res: any = JSON.parse(localStorage.getItem('metering_hierarchy') as string);


        this.apiRequest.apiRequest("metering/metering_hierarchy/", jsonF, body)
            .subscribe(async (res) => {
                console.log(res.message);
                if (res.success) {
                    console.log('Save json metering_hierarchy');
                    if (res.data.meteringFarms) {
                        this.meteringFarms = res.data.meteringFarms;
                        localStorage.setItem("meteringFarmID", res.data.meteringFarms[0].meteringFarmID);
                        localStorage.setItem("meteringFarm", res.data.meteringFarms[0].meteringFarmName);
                        localStorage.setItem("activeLevel", "meteringFarm");
                        
                        for (var i = 0; i < res.data.meteringFarms.length; i++) {
                            //check for metering sections
                            if (res.data.meteringFarms[i].meteringSections.length > 0) {
                                this.meteringSections.push(res.data.meteringFarms[i].meteringSections);
                                localStorage.setItem("meteringSectionID", res.data.meteringFarms[i].meteringSections[0].meteringSectionID);
                                localStorage.setItem("meteringSection", res.data.meteringFarms[i].meteringSections[0].meteringSectionName);

                                for (var j = 0; j < res.data.meteringFarms[i].meteringSections.length; j++) {
                                    localStorage.setItem("hasMeteringSection", "yes");

                                    if (res.data.meteringFarms[i].meteringSections[j].meteringPoints.length > 0) {
                                        this.meteringPointsArr[
                                            res.data.meteringFarms[i].meteringSections[j].meteringSectionID
                                        ] = res.data.meteringFarms[i].meteringSections[j].meteringPoints;

                                        localStorage.setItem("meteringPointID", res.data.meteringFarms[i].meteringSections[j].meteringPoints[0].meteringPointID);
                                        localStorage.setItem("meteringPoint", res.data.meteringFarms[i].meteringSections[j].meteringPoints[0].meteringPointName);

                                        for (var x = 0; x < res.data.meteringFarms[i].meteringSections[j].meteringPoints.length; x++) {
                                            if (res.data.meteringFarms[i].meteringSections[j].meteringPoints[x].meters.length > 0) {
                                            this.deviceList.push(res.data.meteringFarms[i].meteringSections[j].meteringPoints[x].meters)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else if (res.data.meteringSections) {
                        localStorage.setItem("hasMeteringSection", "yes");
                        this.meteringSections = res.data.meteringSections;
                        //demo test
                        localStorage.setItem("meteringSectionID", res.data.meteringSections[0].meteringSectionID);
                        localStorage.setItem("meteringSection", res.data.meteringSections[0].meteringSectionName);

                        localStorage.setItem("activeLevel", "meteringSection");

                        for (var j = 0; j < res.data.meteringSections.length; j++) {
                            if (res.data.meteringSections[j].meteringPoints.length > 0) {
                                this.meteringPointsArr[
                                    res.data.meteringSections[j].meteringSectionID
                                ] = res.data.meteringSections[j].meteringPoints;

                                localStorage.setItem("meteringPointID", res.data.meteringSections[j].meteringPoints[0].meteringPointID);
                                localStorage.setItem("meteringPoint", res.data.meteringSections[j].meteringPoints[0].meteringPointName);

                                for (var x = 0; x < res.data.meteringSections[j].meteringPoints.length; x++) {
                                    if (res.data.meteringSections[j].meteringPoints[x].meters.length > 0) {
                                    this.deviceList.push(res.data.meteringSections[j].meteringPoints[x].meters)
                                    }
                                }
                            }
                        }
                    }
                    else if (res.data.meteringPoints) {
                        this.meteringPoints = res.data.meteringPoints;
                        this.meteringPointsArr[0] = res.data.meteringPoints;
                        localStorage.setItem("meteringPointID", res.data.meteringPoints[0].meteringPointID);
                        localStorage.setItem("meteringPoint", res.data.meteringPoints[0].meteringPointName);

                        localStorage.setItem("activeLevel", "meteringPoint");

                        for (var x = 0; x < res.data.meteringPoints.length; x++) {
                            if (res.data.meteringPoints[x].meters.length > 0) {
                                this.deviceList.push(res.data.meteringPoints[x].meters)
                            }
                        }
                    }


                    if (this.meteringSections.length > 0) {
                        localStorage.setItem("hasMeteringSection", "yes");
                    }
                    if (this.meteringPointsArr.length > 0) {
                        localStorage.setItem("hasMeteringPoint", "yes");
                    }

                    //this.router.navigate(['/dashboard']);

                    //window.location.assign('/dashboard')
                    window.location.assign('/dashboard/users')

                    // setTimeout(() =>{
                    //     this.router.navigate(['/dashboard/users']);
                    // },1000)

                }
                else {
                    // Keep session intact on hierarchy payload issues.
                    return;
                }
                this.changeDetectorRef.detectChanges();
            },
               async (error: any) => {
                    const defaultOptions = {
                        autohide: true,
                        delay: 10000,
                    };
                    console.log(error);
                    let message = "";
                    for (var i = 0; i < error.error.data.length; i++) {
                        message += error.error.data[i] + "\n";
                    }
                    // Keep session intact on hierarchy request failures.
                    this.toastService.show("Smart-View Login", "You account setup is not complete. \nContact your Administrator for more information.", { headerClasses: 'bg-danger text-light', ...defaultOptions })
                });
    }

    logoutFromBackend(): Promise<any> {
        return firstValueFrom(
          this.apiRequest.apiRequest("auth/logout", "auth_logout.json", {})
        ).then((res) => {
          this.changeDetectorRef.detectChanges();
          return res;
        }).catch((error) => {
          const defaultOptions = {
            autohide: true,
            delay: 5000,
          };
      
          console.log(error);
          let message = "";
          for (var i = 0; i < error.error?.data?.length; i++) {
            message += error.error.data[i] + "\n";
          }
      
          this.toastService.show("Logout Error", "There was an error logging you out.", {
            headerClasses: 'bg-danger text-light',
            ...defaultOptions
          });
      
          throw error;
        });
      }

    
}
